import {
  createSurvey,
  saveSurveySettings,
  LOAD_SUCCESSFUL_ACTION,
  loadSurvey,
  loadSurveyVersion,
  SURVEY_ACTIVATION_PERIOD,
  SURVEY_FUNDING_AREA,
  SURVEY_IDENTIFIER,
  SURVEY_LANGUAGE,
  SURVEY_NAME,
  SURVEY_PROGRAM,
  SURVEY_PROGRAM_INSTANCE,
  SURVEY_PROJECT,
  SURVEY_TEMPLATE
} from "./survey";
import { PROPERTY_NAME, PROPERTY_VALUE, TYPE_KEY } from "../common/constant";
import { createErrorMessages, createBackendErrorMessages, messagesReceived } from "./message";

import { coalesce } from "../utils/ObjectUtils";
import rest from "../common/rest";
import { setPropertyValue } from "./fundingArea";

const NEW_ACTION = "SURVEY_SETTINGS.NEW_ACTION";
const SURVEY_SETTINGS_ACTION = "SURVEY_SETTINGS.SURVEY_SETTINGS_ACTION";
const CLOSE_SETTINGS_ACTION = "SURVEY_SETTINGS.CLOSE_SETTINGS_ACTION";
const SETTINGS_ERROR_ACTION = "SURVEY_SETTINGS.SETTINGS_ERROR_ACTION";
const CHANGE_PROPERTY_ACTION = "SURVEY_SETTINGS.CHANGE_PROPERTY_ACTION";
const UPDATE_SURVEY_DATA_ACTION = "SURVEY_SETTINGS.UPDATE_SURVEY_DATA_ACTION";
const LOAD_LIST_SUCCESSFUL_ACTION = "SURVEY_SETTINGS.LOAD_LIST_SUCCESSFUL_ACTION";

const PROPERTY_ID = "propetyId";
export const SURVEY_SHOW_PROPERTY_DIALOG = "surveyShowPropertyDialog";
export const SURVEY_IS_NEW = "surveyIsNew";
export const SURVEY_IS_COPY = "surveyIsCopy";
export const FIELD_ERROR_MESSAGES = "fieldErrorMessages";
export const TEMPLATE_LANGUAGES = "templateLanguages";
export const NUMBER_OF_PROJECTS_TO_ATIVATE = "numberOfProjectsToActivate";

const initialState = {
  [SURVEY_SHOW_PROPERTY_DIALOG]: false,
  [SURVEY_IS_NEW]: true,
  [FIELD_ERROR_MESSAGES]: {},
  [SURVEY_NAME]: "",
  [SURVEY_FUNDING_AREA]: {},
  [SURVEY_PROGRAM]: {},
  [SURVEY_PROGRAM_INSTANCE]: {},
  [SURVEY_PROJECT]: {},
  [SURVEY_LANGUAGE]: {},
  [SURVEY_IS_COPY]: false,
  [SURVEY_TEMPLATE]: null
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case NEW_ACTION:
      newState = Object.assign({}, state, initialState);
      newState[SURVEY_SHOW_PROPERTY_DIALOG] = true;
      newState[SURVEY_IS_NEW] = true;
      newState[SURVEY_IS_COPY] = action[SURVEY_IS_COPY];
      newState[SURVEY_TEMPLATE] = null;
      newState[SURVEY_NAME] = "";
      newState[SURVEY_LANGUAGE] = coalesce(action[SURVEY_LANGUAGE], { id: "de", name: "Deutsch" });
      break;
    case LOAD_SUCCESSFUL_ACTION:
      newState = handleLoadTemplate(state, action);
      break;
    case SURVEY_SETTINGS_ACTION:
      newState = Object.assign({}, state, {
        [SURVEY_IDENTIFIER]: action[SURVEY_IDENTIFIER],
        [SURVEY_NAME]: action[SURVEY_NAME],
        [FIELD_ERROR_MESSAGES]: {},
        [SURVEY_FUNDING_AREA]: action[SURVEY_FUNDING_AREA],
        [SURVEY_PROGRAM]: action[SURVEY_PROGRAM],
        [SURVEY_PROGRAM_INSTANCE]: action[SURVEY_PROGRAM_INSTANCE],
        [SURVEY_PROJECT]: action[SURVEY_PROJECT],
        [SURVEY_LANGUAGE]: coalesce(action[SURVEY_LANGUAGE], { id: "de", name: "Deutsch" }),
        [SURVEY_IS_NEW]: false,
        [SURVEY_IS_COPY]: false,
        [SURVEY_SHOW_PROPERTY_DIALOG]: true
      });
      break;
    case CLOSE_SETTINGS_ACTION:
      newState = Object.assign({}, state, { [SURVEY_SHOW_PROPERTY_DIALOG]: false });
      break;
    case SETTINGS_ERROR_ACTION:
      newState = Object.assign({}, state, { [FIELD_ERROR_MESSAGES]: action[FIELD_ERROR_MESSAGES] });
      break;
    case CHANGE_PROPERTY_ACTION:
      newState = Object.assign({}, state, { [action[PROPERTY_ID]]: action[PROPERTY_VALUE] });
      break;
    case UPDATE_SURVEY_DATA_ACTION:
      newState = Object.assign({}, state, {
        [SURVEY_FUNDING_AREA]: action[SURVEY_FUNDING_AREA],
        [SURVEY_PROGRAM]: action[SURVEY_PROGRAM],
        [SURVEY_PROGRAM_INSTANCE]: action[SURVEY_PROGRAM_INSTANCE],
        [SURVEY_PROJECT]: action[SURVEY_PROJECT]
      });
      break;
    case LOAD_LIST_SUCCESSFUL_ACTION:
      newState = Object.assign({}, state, {
        [action[PROPERTY_NAME]]: action[PROPERTY_VALUE]
      });
      break;
    default:
      newState = Object.assign({}, state, {});
      break;
  }
  return newState;
}
function handleLoadTemplate(state, action) {
  let surveyName = state[SURVEY_IS_COPY] ? state[SURVEY_NAME] : action[SURVEY_NAME];
  return Object.assign({}, state, {
    [SURVEY_NAME]: surveyName,
    [SURVEY_FUNDING_AREA]: action[SURVEY_FUNDING_AREA],
    [SURVEY_PROGRAM]: action[SURVEY_PROGRAM],
    [SURVEY_PROGRAM_INSTANCE]: action[SURVEY_PROGRAM_INSTANCE],
    [SURVEY_PROJECT]: action[SURVEY_PROJECT],
    [SURVEY_LANGUAGE]: action[SURVEY_LANGUAGE],
    [SURVEY_TEMPLATE]: action[SURVEY_TEMPLATE]
  });
}

export function filterSelected(fundingArea, program, programInstance, project) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: UPDATE_SURVEY_DATA_ACTION,
      [SURVEY_FUNDING_AREA]: fundingArea,
      [SURVEY_PROGRAM]: program,
      [SURVEY_PROGRAM_INSTANCE]: programInstance,
      [SURVEY_PROJECT]: project
    });
  };
}

/**
 * New survey action
 */
export function newSurvey(isCopy = false) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: NEW_ACTION,
      [SURVEY_IS_COPY]: isCopy
    });
    dispatch(setPropertyValue("selectedFundingArea", "settings", null));
    dispatch(setPropertyValue("selectedProgram", "settings", null));
    dispatch(setPropertyValue("selectedProgramInstance", "settings", null));
  };
}

export function copySurveyTemplate(survey, copySuffix, history) {
  return (dispatch, getState) => {
    newSurvey(true)(dispatch, getState);

    // if there is histor- we should load chosen version of template - otherwise the latest one
    if (history) {
      loadSurveyVersion(survey, history, false)(dispatch, getState);
    } else {
      loadSurvey(survey, null, false)(dispatch, getState);
    }

    let { fundingArea, program, programInstance, surveyName } = survey;
    dispatch(handleCopiedTemplateName(surveyName, copySuffix));
    if (fundingArea) {
      dispatch(
        setPropertyValue("selectedFundingArea", "settings", {
          id: fundingArea.id,
          name: fundingArea.name,
          type: fundingArea.type
        })
      );
    } else {
      dispatch(setPropertyValue("selectedFundingArea", "settings", null));
    }

    if (program) {
      dispatch(
        setPropertyValue("selectedProgram", "settings", { id: program.id, name: program.name, type: program.type })
      );
    } else {
      dispatch(setPropertyValue("selectedProgram", "settings", null));
    }

    if (programInstance) {
      dispatch(
        setPropertyValue("selectedProgramInstance", "settings", {
          id: programInstance.id,
          name: programInstance.name,
          type: programInstance.type
        })
      );
    } else {
      dispatch(setPropertyValue("selectedProgramInstance", "settings", null));
    }
  };
}

export function loadSurveySettings(template, activate) {
  let { identifier, surveyName, language, fundingArea, program, programInstance } = template;
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: SURVEY_SETTINGS_ACTION,
      [SURVEY_IDENTIFIER]: identifier,
      [SURVEY_NAME]: surveyName,
      [SURVEY_LANGUAGE]: language,
      [SURVEY_FUNDING_AREA]: fundingArea,
      [SURVEY_PROGRAM]: program,
      [SURVEY_PROGRAM_INSTANCE]: programInstance
    });

    if (fundingArea) {
      dispatch(
        setPropertyValue("selectedFundingArea", "settings", {
          id: fundingArea.id,
          name: fundingArea.name,
          type: fundingArea.type
        })
      );
    } else {
      dispatch(setPropertyValue("selectedFundingArea", "settings", null));
    }

    if (program) {
      dispatch(
        setPropertyValue("selectedProgram", "settings", { id: program.id, name: program.name, type: program.type })
      );
    } else {
      dispatch(setPropertyValue("selectedProgram", "settings", null));
    }

    if (programInstance) {
      dispatch(
        setPropertyValue("selectedProgramInstance", "settings", {
          id: programInstance.id,
          name: programInstance.name,
          type: programInstance.type
        })
      );
    } else {
      dispatch(setPropertyValue("selectedProgramInstance", "settings", null));
    }
  };
}

export function closeSettings() {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: CLOSE_SETTINGS_ACTION
    });
  };
}

export function submitSettings(isNew = true) {
  return (dispatch, getState) => {
    let {
      surveyName,
      surveyLanguage,
      surveyTemplate,
      surveyFundingArea,
      surveyProgram,
      surveyProgramInstance,
      surveyProject
    } = getState().surveySettings;
    if (surveyName === undefined || surveyName === null || surveyName === "") {
      dispatch({
        [TYPE_KEY]: SETTINGS_ERROR_ACTION,
        [FIELD_ERROR_MESSAGES]: { surveyName: "survey.settings.titleIsRequired" }
      });
    } else {
      if (isNew) {
        createSurvey(
          surveyName,
          surveyFundingArea,
          surveyProgram,
          surveyProgramInstance,
          surveyProject,
          surveyLanguage,
          surveyTemplate
        )(dispatch);
      } else {
        saveSurveySettings(getState().surveySettings[SURVEY_IDENTIFIER], surveyName)(dispatch, getState);
      }
      closeSettings()(dispatch);
    }
  };
}

export function changeProperty(propetyId, propertyValue) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
      [PROPERTY_ID]: propetyId,
      [PROPERTY_VALUE]: propertyValue
    });
  };
}

/**
 * Get number of projects to be activated  from server, /admin/surveylanguages
 */
export function getNumberOfActivatedProjects() {
  return (dispatch, getState) => {
    let { surveyProject } = getState().surveySettings;
    rest.doGet(`/admin/admin/activatedProjects/${surveyProject}`).then(
      (json) => {
        if (json) {
          dispatch(loadSuccessful(NUMBER_OF_PROJECTS_TO_ATIVATE, json));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

/**
 * Get languages for templates  from server, /admin/surveylanguages
 */
export function loadTemplateLanguages() {
  return (dispatch) => {
    rest.doGet(`/admin/admin/surveylanguages`).then(
      (json) => {
        if (json) {
          dispatch(loadSuccessful(TEMPLATE_LANGUAGES, json.languages));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

/**
 * Get periods for templates  from server, /admin/reportingperiods
 */
export function loadReportingPeriods() {
  return (dispatch) => {
    rest.doGet(`/admin/admin/reportingperiods`).then(
      (json) => {
        if (json) {
          dispatch(loadSuccessful(SURVEY_ACTIVATION_PERIOD, json));
        } else {
          dispatch(messagesReceived(createErrorMessages(json)));
        }
      },
      (reason) => {
        dispatch(messagesReceived(createBackendErrorMessages(reason)));
      }
    );
  };
}

export function loadSuccessful(propertyName, json) {
  return {
    [TYPE_KEY]: LOAD_LIST_SUCCESSFUL_ACTION,
    [PROPERTY_NAME]: propertyName,
    [PROPERTY_VALUE]: json
  };
}

export function handleCopiedTemplateName(surveyName, copySuffix) {
  return (dispatch) => {
    dispatch({
      [TYPE_KEY]: CHANGE_PROPERTY_ACTION,
      [PROPERTY_ID]: "surveyName",
      [PROPERTY_VALUE]: surveyName + " " + copySuffix
    });
  };
}
